"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUvsTimedOut = useUvsTimedOut;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
function useUvsTimedOut(_ref) {
  var uvsEntities = _ref.uvsEntities,
    _ref$timeoutMs = _ref.timeoutMs,
    timeoutMs = _ref$timeoutMs === void 0 ? 60000 : _ref$timeoutMs;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    timedOut = _useState2[0],
    setTimedOut = _useState2[1];
  var transitioningStreams = uvsEntities === null || uvsEntities === void 0 ? void 0 : uvsEntities.filter(function (endpoint) {
    return endpoint.status === 'STARTING' || endpoint.status === 'STOPPING';
  });
  var latestModifiedOn = transitioningStreams.reduce(function (accumulator, stream) {
    return Math.max(accumulator, stream.modifiedOn);
  }, 0);
  (0, _react.useEffect)(function () {
    if (transitioningStreams.length > 0) {
      var timeElapsed = Date.now() - latestModifiedOn;
      var remainingTime = timeoutMs - timeElapsed;
      if (remainingTime <= 0) {
        setTimedOut(true);
      } else {
        var timer = setTimeout(function () {
          setTimedOut(true);
        }, remainingTime);
        return function () {
          return clearTimeout(timer);
        };
      }
    } else {
      setTimedOut(false);
    }
  }, [latestModifiedOn, transitioningStreams.length, timeoutMs]);
  return timedOut;
}